import { PipeTransform, Pipe } from '@angular/core';
import { LocalStorage } from '@df/browser/storage/decorator/local-storage';

@Pipe({
    name: 'lastCategoryPath',
    standalone: true
})
export class LastCategoryPathPipe implements PipeTransform {
    @LocalStorage('lastCategoryPath')
    protected lastSeenCategory?: string;

    transform(value: string): string {
        return this.lastSeenCategory || value;
    }
}
